import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import MainCard from 'components/MainCard';
import useApi from 'hooks/useApi';
import { formatDateWithTimezoneDisplay } from 'utils/dateFormat';

const TransactionHistory = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [historyData, setHistoryData] = useState<any>(null);

  const { transUid } = useParams();
  // console.log("transaction uid",transUid)
  const { getTransactionHistory } = useApi();

  const loadHistory = async (transId: any) => {
    try {
      setLoading(true);
      const response = await getTransactionHistory(transId);
      setHistoryData(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error loading flow:', err);
    }
  };

  useEffect(() => {
    loadHistory(transUid);
  }, []);

  return (
    <div>
      <Box display="flex" alignItems="center" gap={1} margin={1}>
        <ArrowBackIcon onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />
        <Typography variant="h4" component="h2">
          {' '}
          <strong> Transaction History: </strong>{' '}
        </Typography>
      </Box>
      <MainCard>
        <Box sx={{ overflowX: 'hidden' }}>
          <Table stickyHeader sx={{ tableLayout: 'fixed', width: '100%', paddingRight: '20px' }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '20%' }}>Details</TableCell>
                <TableCell style={{ width: '30%' }}>Location</TableCell>
                <TableCell style={{ width: '20%' }}>Initiated By</TableCell>
                <TableCell style={{ width: '20%' }}>Status</TableCell>
                <TableCell style={{ width: '10%' }}>Info</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  {' '}
                  <TableCell colSpan={5} align="center">
                    {' '}
                    <CircularProgress size={24} />
                  </TableCell>{' '}
                </TableRow>
              ) : historyData?.length > 0 ? (
                historyData?.map((row: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell style={{ width: '25%' }}>
                      <Typography variant="body2">
                        {' '}
                        <strong>Type:</strong> <span style={{ color: 'blueviolet' }}> {row?.eventType}</span>{' '}
                      </Typography>
                      <Typography variant="body2">
                        {' '}
                        <strong>Team:</strong> {row?.team?.name}{' '}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: '25%' }}>
                      <Typography variant="body2">
                        {' '}
                        <strong>Time:</strong> {row?.createdAt ? formatDateWithTimezoneDisplay(row.createdAt) : ''}{' '}
                      </Typography>
                      <Typography variant="body2">
                        {' '}
                        <strong>Location:</strong> {row?.location?.location}{' '}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: '20%' }}>
                      <Typography variant="body2">
                        {' '}
                        {row?.user?.firstName} {row?.user?.lastName}{' '}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: '25%' }}>
                      <Typography variant="body2">
                        <span
                          style={{
                            color:
                              row?.eventStatus === 'COMPLETED'
                                ? 'green'
                                : row?.eventStatus === 'MISSED_CALL'
                                ? 'red'
                                : row?.eventStatus === 'CALLING'
                                ? 'skyblue'
                                : row?.eventStatus === 'RECEIVED'
                                ? 'blue'
                                : row?.eventStatus === 'MANUAL_DISCONNECT'
                                ? 'hotpink'
                                : row?.eventStatus === 'IN_PROGRESS'
                                ? 'orange'
                                : 'inherit'
                          }}
                        >
                          {' '}
                          {row?.eventStatus}
                        </span>
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: '5%' }}>
                      <InfoIcon style={{ cursor: 'pointer' }} color="primary" onClick={() => navigate(`/event/details/${row?.uid}`)} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    {' '}
                    No data found.{' '}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </MainCard>
    </div>
  );
};

export default TransactionHistory;
